import React, { useState } from 'react';
import Input from '../general/Input/Input';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faRotateLeft, faCheck } from '@fortawesome/free-solid-svg-icons';
import Tooltip from '../Tooltip/Tooltip';
import './EditableField.css';

const EditableField = ({
  label,
  tooltip,
  description,
  error,
  value,
  onChange,
  suffix = '',
  prefix = '',
  type = 'number',
  locale = 'pt-BR',
  currency
}) => {
  const [editando, setEditando] = useState(false);
  const [localValue, setLocalValue] = useState(value);
  const [originalValue, setOriginalValue] = useState(value);

  const formatValue = (val) => {
    if (currency) {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2
      }).format(Number(val) || 0);
    }
    return `${prefix}${val ?? ''}${suffix}`;
  };

  const handleEdit = () => {
    setOriginalValue(value);
    setLocalValue(value);
    setEditando(true);
  };

  const handleRestore = () => {
    setLocalValue(originalValue);
    onChange(originalValue);
    setEditando(false);
  };

  const handleConfirm = () => {
    onChange(localValue);
    setEditando(false);
  };

  return (
    <div className="editable-field-wrapper">
      {/* Label + Tooltip */}
      {label && (
        <label className="editable-label">
          {label}
          {tooltip && <Tooltip description={tooltip} />}
        </label>
      )}

      {/* Descrição */}
      {description && (
        <small className="editable-description">{description}</small>
      )}

      {/* Campo editável */}
      <div className={`editable-field ${error ? 'error' : ''}`}>
        {editando ? (
          <>
            <Input
              type={type}
              value={localValue ?? ''}
              onChange={(e) =>
                setLocalValue(
                  type === 'number' && e.target.value !== ''
                    ? Number(e.target.value)
                    : e.target.value
                )
              }
              autoFocus
            />
            <div className="editable-icons">
              <FontAwesomeIcon
                icon={faCheck}
                className="icon-confirm"
                title="Confirmar"
                onClick={handleConfirm}
              />
              <FontAwesomeIcon
                icon={faRotateLeft}
                className="icon-restore"
                title="Restaurar valor original"
                onClick={handleRestore}
              />
            </div>
          </>
        ) : (
          <>
            <span>{formatValue(value)}</span>
            <FontAwesomeIcon
              icon={faPen}
              className="icon-pencil"
              title="Editar"
              onClick={handleEdit}
            />
          </>
        )}
      </div>

      {/* Erro */}
      {error && <div className="editable-error">{error}</div>}
    </div>
  );
};

export default EditableField;
